module.exports = __webpack_public_path__ + "images/gray_bg1-66f7c93d79.png";